// extracted by mini-css-extract-plugin
export default {"Wrap":"Pagination_Wrap__9czv6","WrapCustom":"Pagination_WrapCustom__xJKIS","WrapDefault":"Pagination_WrapDefault__KcDDe"};